import {APIURLLEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async enviarEmailAdjunto(body) {
    const url=APIURLLEGALES + "/general/EnviarEmailConAdjunto"
    const response = apiClient.post(url, body)
    const data = await response
    return data;
  }

  async enviarEmail(body) {
    const url=APIURLLEGALES + "/general/EnviarEmail"
    const response = apiClient.post(url, body)
    const data = await response
    return data;
  }
  
}

export default ApiServiceAdapter;